import customToast from "../components/Common/CustomToast";

export const renderError = (ex)=>{
    if(ex.response && ex.response.status === 500)
        customToast.error(ex.response.data);
    else 
        customToast.error(ex.message);
}
